"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const Message_1 = __importDefault(require("../../components/message/Message"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemActions_1 = __importDefault(require("../../actions/RedeemActions"));
const RedeemContainer_1 = __importDefault(require("./RedeemContainer"));
const SuccessStageStyled_1 = __importDefault(require("./SuccessStageStyled"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const route_1 = require("../../utils/route");
class SuccessStage extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.isSupported = () => {
            const os = this.getOs();
            const supportedOS = this.props.supportedOS || ['windows'];
            return supportedOS.indexOf(os) >= 0;
        };
        this.getDownloadUrl = () => {
            let url = this.props.pcDownloadUrl || '#';
            const isSupported = this.isSupported();
            const os = this.getOs();
            if (isSupported) {
                switch (os) {
                    case 'windows':
                        url = this.props.pcDownloadUrl;
                        break;
                    case 'mac':
                        url = this.props.macDownloadUrl;
                        break;
                    case 'ios':
                        url = this.props.iosDownloadUrl;
                        break;
                    case 'android':
                        url = this.props.androidDownloadUrl;
                        break;
                    default:
                        url = this.props.pcDownloadUrl;
                }
            }
            return url;
        };
        this.getOs = () => {
            let os = 'windows';
            if (window_or_global_1.default._epicGamesNav.browser.mac) {
                os = 'mac';
            }
            else if (window_or_global_1.default._epicGamesNav.browser.linux) {
                os = 'linux';
            }
            else if (window_or_global_1.default._epicGamesNav.browser.ios) {
                os = 'ios';
            }
            else if (window_or_global_1.default._epicGamesNav.browser.android) {
                os = 'android';
            }
            return os;
        };
    }
    componentWillUnmount() {
        RedeemActions_1.default.resetFlow.defer();
    }
    render() {
        const inlineHomeButton = (react_1.default.createElement(react_router_dom_1.Link, { className: "btn btn-default inline btn-fixed-width", to: route_1.generateRouteTo('/', this.props.location) },
            react_1.default.createElement(Message_1.default, { code: "epic.common.back_to_home" })));
        const isSupported = this.isSupported();
        const os = this.getOs();
        const successClass = os === 'mobile' ? 'successMobile' : '';
        const successMessage = isSupported ? 'epic.code.redemption.success.msg' : 'epic.code.redemption.success.msg.other';
        const downloadUrl = this.getDownloadUrl();
        return (react_1.default.createElement(SuccessStageStyled_1.default, { className: "successStage" },
            react_1.default.createElement(RedeemContainer_1.default, { className: "redeemContainer" },
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.success.title" })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: successClass },
                        react_1.default.createElement("p", null,
                            react_1.default.createElement(Message_1.default, { code: successMessage })),
                        react_1.default.createElement("div", { className: "site-block-header" },
                            react_1.default.createElement("h1", { className: "site-block-title" },
                                react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.success.subtitle" })),
                            react_1.default.createElement("div", { className: "clearfix" })),
                        react_1.default.createElement("div", { className: "buttonContainer row" },
                            isSupported ? (react_1.default.createElement("div", { className: "col-sm-6" },
                                react_1.default.createElement("a", { className: "btn btn-primary inline btn-fixed-width", href: downloadUrl },
                                    react_1.default.createElement(Message_1.default, { code: "epic.common.download" })))) : null,
                            os === 'linux' ? (react_1.default.createElement("div", { className: "alternateDownload" },
                                react_1.default.createElement("a", { className: "btn btn-default inline btn-fixed-width", href: this.props.pcDownloadUrl },
                                    react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.success.download_windows" })))) : null,
                            react_1.default.createElement("div", { className: "col-sm-6" }, inlineHomeButton)))))));
    }
}
SuccessStage.propTypes = {
    pcDownloadUrl: prop_types_1.default.string,
    macDownloadUrl: prop_types_1.default.string,
    iosDownloadUrl: prop_types_1.default.string,
    androidDownloadUrl: prop_types_1.default.string,
    supportedOS: prop_types_1.default.array,
    location: prop_types_1.default.object
};
exports.default = react_router_dom_1.withRouter(SuccessStage);
//# sourceMappingURL=SuccessStage.js.map